function lazyLoadImage(item) {
  if (!window.cachedPlaceholder) {
    window.cachedPlaceholder = {};
  }

  if (!window.cachedPlaceholder[item.src]) {
    window.cachedPlaceholder[item.src] = new Image();
    window.cachedPlaceholder[item.src].src = item.src;
  }

  const image = new Image();
  const src = item.getAttribute("data-src");

  if (null === src) {
    return;
  }

  item.onload = null;
  image.src = src;

  image.onload = function () {
    item.setAttribute("src", src);
  };
}

function defer(fn) {
  window.addEventListener("DOMContentLoaded", fn);
}

$(function () {
  const $nav = $(".top-marker"),
    $headerContainer = $("body, .header-container, .nav-panel"),
    $loginContainer = $(".login-container"),
    $body = $("body");
  let $header = $(".parallax");
  $header.ready(function () {
    $header = $(".parallax");
    $(document).scroll(function () {
      $header.css(
        "background-position",
        "50% calc(50% + " + $(window).scrollTop() / 4 + "px)"
      );
      $headerContainer.toggleClass(
        "scrolled",
        $(window).scrollTop() > $nav.height()
      );
    });
  });
  headerHeightCallback = function () {
    const $activeNav = $(".nav.active .nav-panel .content"),
      $burgerMenu = $loginContainer.find(".panel ul"),
      scrollTop = $(window).scrollTop();
    if (
      $activeNav.length > 0 &&
      $activeNav.outerHeight() + $activeNav.offset().top - scrollTop >
        window.innerHeight
    ) {
      $activeNav
        .css(
          "height",
          window.innerHeight - $activeNav.offset().top + scrollTop - 10
        )
        .css("overflow", "auto");
      $body.addClass("fixed");
    } else if (
      $burgerMenu.length > 0 &&
      $burgerMenu.outerHeight() + $burgerMenu.offset().top - scrollTop >
        window.innerHeight
    ) {
      $burgerMenu
        .css(
          "height",
          window.innerHeight - $burgerMenu.offset().top + scrollTop - 30
        )
        .css("overflow", "auto");
    }
  };
  const resetHeaderHeight = function () {
    $(".nav.active .nav-panel .content")
      .css("height", "auto")
      .css("overflow", "initial");
    $loginContainer
      .find(".panel ul")
      .css("height", "auto")
      .css("overflow", "initial");
  };
  $(window).resize(function () {
    resetHeaderHeight();
    setTimeout(headerHeightCallback, 100);
  });
  if ($(window).scrollTop() > $nav.height()) {
    $headerContainer.addClass("scrolled");
  }
  $loginContainer.click(function (e) {
    const target = e.target;
    const isBurgerIcon = target.classList.contains("burger");
    if ("A" === target.nodeName && !isBurgerIcon) {
      closeLoginMenu();

      return;
    }
    if ("A" !== target.nodeName || isBurgerIcon) {
      e.preventDefault();
    }
    $(this).addClass("active");
    headerHeightCallback();
  });
  const closeLoginMenu = function () {
    const $activeLoginContainer = $(".login-container.active");
    if (0 === $activeLoginContainer.length) {
      return;
    }
    $activeLoginContainer.removeClass("active");
    $activeLoginContainer.removeClass("back");
    resetHeaderHeight();
  };
  $loginContainer.mouseleave(function () {
    if (window.isMobile) {
      return;
    }
    closeLoginMenu();
  });
  const $navs = $(".nav");
  const closeNavCallback = function () {
    const $activeNav = $(".nav.active");
    if (0 === $activeNav.length) {
      console.log($activeNav.length);
      return;
    }
    $(".search-input").removeClass("back");
    resetHeaderHeight();
    if ($body.hasClass("fixed")) {
      $body.removeClass("fixed");
    }
    $activeNav.removeClass("active");
  };

  $navs.click(function (e) {
    closeNavCallback();
    const $this = $(this);
    if ($this.hasClass("active")) {
      const $navButton = $(this).find("a.access"),
        target = e.target;
      if (
        "A" === target.nodeName ||
        $navButton.is(target) ||
        $navButton.has(target).length > 0
      ) {
        closeNavCallback();
      }
    } else {
      if (window.isMobile) {
        closeNavCallback();
      }
      $this.addClass("active");
      headerHeightCallback();
    }
  });
  $(document).click(function (e) {
    if (!window.isMobile) {
      return;
    }
    const $activeNav = $(".nav.active");
    console.log($activeNav);
    const $activeLoginContainer = $(".login-container.active");
    const target = e.target;
    if (
      (0 === $activeNav.length ||
        $activeNav.is(target) ||
        $activeNav.has(target).length > 0) &&
      (0 === $activeLoginContainer.length ||
        $activeLoginContainer.is(target) ||
        $activeLoginContainer.has(target).length > 0)
    ) {
      return true;
    }
    e.preventDefault();
    closeNavCallback();
    closeLoginMenu();
    return false;
  });

  $(document).click(function (event) {
    if (!$(event.target).closest(".nav").length) {
      closeNavCallback();
    }
  });

  const $regionSelect = $(".region-select");
  if ($regionSelect.length) {
    $body.addClass("region");
    $(".footer-container").after('<div class="region-spacer"></div>');
    $(".region-spacer").css("height", $regionSelect.outerHeight());
  }
  if ($body.hasClass("neon")) {
    $(".neon-toggle").addClass("checked");
  } else {
    $(".neon-toggle").removeClass("checked");
  }

  if ($body.hasClass("no-autoplay")) {
    $(".autoplay-toggle").removeClass("checked");
  } else {
    $(".autoplay-toggle").addClass("checked");
  }

  $("body:not(.no-autoplay) .listing-games .cover").on(
    "mouseenter",
    function () {
      $(this).removeAttr("title");
    }
  );
});

$(function () {
  const $searchContainer = $("#ig-search"),
    $searchBar = $("#ig-header-search-box-input");

  $searchContainer.click(function () {
    $("body").addClass("blur");
    $(".advanced, .ig-search").addClass("opacity");
    $(".search-input").addClass("wide").focus();
  });

  $(document).click(function (e) {
    if (
      $(e.target).closest("#ig-search").attr("id") !== "ig-search" &&
      !$searchContainer.hasClass("search-clear")
    ) {
      $("body").removeClass("blur");
      $(".advanced, .ig-search").removeClass("opacity");
      $(".search-input").removeClass("wide");
    }
  });
});

$(function () {
  const $body = $("body");
  let timer = null;
  let videoId = 0;
  let videoPromises = [];
  $body
    .on("mouseenter", "a.video", playVideo)
    .on("mouseleave", "a.video", pauseVideo);
  function playVideo() {
    if ($body.hasClass("no-autoplay")) {
      return false;
    }
    const $this = $(this);
    const $video = $this.find("video");
    const videoObject = $video.get(0);
    if ($video.length > 0) {
      if ($this.hasClass("played")) {
        videoObject.play();
      } else {
        timer = setTimeout(
          () => {
            $video.data("video-id", videoId);
            const promise = videoObject.play();
            if (promise) {
              videoPromises[videoId++] = promise;
            } else {
              $body
                .addClass("no-autoplay")
                .off("mouseenter", "a.video")
                .off("mouseleave", "a.video");
              return;
            }
            videoObject.oncanplay = function () {
              $this.addClass("is-playable");
              if (!$this.hasClass("played")) {
                $this.addClass("played");
              }
            };
          },
          window.isMobile ? 0 : 200
        );
      }
      $this.data("title", $this.attr("title"));
      $this.removeAttr("title");
    }
  }
  function pauseVideo() {
    const $this = $(this);
    const $video = $this.find("video");
    if (timer) {
      clearTimeout(timer);
    }
    if ($video.length > 0) {
      if ($video.data("video-id")) {
        const currentVideoId = parseInt($video.data("video-id"));
        videoPromises[currentVideoId].then(function () {
          $video.get(0).pause();
          delete videoPromises[currentVideoId];
          $video.data("video-id", false);
        });
      } else {
        $video.get(0).pause();
      }
    }
    $this.attr("title", $this.data("title"));
    $this.removeData("title");
  }
});
